import { Link } from '@chakra-ui/react';
import { createSearchParams } from 'react-router-dom';
import { useEventInfo, useEventSourceCode } from '@frx/frx-react-context';
import { standardizeUrl } from '@frx/frx-services';
import { useAppProvider } from '../../context';
import { useFormOwner, useLowercaseQueryString } from '../../hooks';

export const DonateByMail = () => {
  const {
    queryStrings: { proxy_id, fr_id },
  } = useLowercaseQueryString();
  const {
    data: { user },
  } = useAppProvider();
  const { data: eventInfo } = useEventInfo();
  const { data: sourceCode } = useEventSourceCode({
    id: fr_id,
    zipCode: user?.primary_address?.zip || eventInfo?.zip || '',
  });
  const { data: formOwnerData } = useFormOwner();

  const search = createSearchParams({
    trID: String(sourceCode?.eventCode),
    sourceCode: String(sourceCode?.sourceCode),
    participantName: formOwnerData?.formOwner,
    pagename: 'PrintableGiftForm',
    eventName: String(eventInfo?.name),
    programName: 'St. Jude Events',
    donType:
      Number(proxy_id) === Number(eventInfo?.id) ? 'event' : 'participant',
    consID: proxy_id,
    mailingAddress: '',
  });

  const toUrl = standardizeUrl(`/site/SPageServer/?${search.toString()}`, true);

  return (
    <Link href={toUrl} isExternal>
      <strong>Donating by mail?</strong>
    </Link>
  );
};
